import { VidyoCommonState } from "@/features/vidyo-call/types/vidyo-common";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { Participant } from "../types/participant";

export function getCurrentParticipantSelector(
  state: VidyoCommonState,
): Participant | undefined {
  const participants = state.participants.participants;
  return participants.find((p) => p.isCurrentUser);
}

export function getCurrentParticipant(): Participant | undefined {
  return getCurrentParticipantSelector(useVidyoStore.getState());
}
